/** JA translations for Les Aiguilles Blanches */
const ja: Record<string, string> = {
  subtitle: "圧雪車シミュレーター",
  startGame: "ゲーム開始",
  resumeGame: "再開",
  newGame: "ニューゲーム",
  // UNUSED continue: "続ける",
  settings: "設定",
  controls: "操作",
  changelog: "更新情報",
  howToPlay: "遊び方",
  fullscreen: "フルスクリーン",
  fullscreenHint: "Fキーでフルスクリーン",
  exitFullscreen: "フルスクリーン解除",
  back: "戻る",
  backToGame: "ゲームに戻る",
  // UNUSED loading: "読み込み中...",
  inputKeyboard: "✓ キーボード検出",
  inputKeyboardOff: "✗ キーボードなし",
  inputTouch: "✓ タッチスクリーン検出",
  inputTouchOff: "✗ タッチスクリーン未検出",
  inputGamepad: "✓ ゲームパッド接続済み",
  inputGamepadOff: "✗ ゲームパッドなし",
  updateAvailable: "新しいバージョンがあります — タップで更新",
  madeIn: "❄️ サヴォワ製",
  feedback: "フィードバックを送る",
  on: "✓ オン",
  off: "✗ オフ",
  zoneClosed: "🚫 エリア閉鎖",

  // Settings
  language: "言語",
  accessibility: "アクセシビリティ",
  highContrast: "ハイコントラスト",
  reducedMotion: "モーション軽減",
  showFps: "FPS表示",
  showDebug: "デバッグ情報",
  skiStyle: "スタイル",
  skiTricks: "トリック",
  skiBestCombo: "ベストコンボ",
  quitGame: "ゲーム終了",
  display: "表示",
  displayWindowed: "ウィンドウ",
  displayFullscreen: "フルスクリーン",
  displayBorderless: "ボーダーレス",
  colorblindMode: "色覚補助",
  none: "なし",
  deuteranopia: "2型",
  protanopia: "1型",
  tritanopia: "3型",
  // UNUSED move: "移動",
  moveUp: "上",
  moveDown: "下",
  moveLeft: "左",
  moveRight: "右",
  groom: "圧雪",
  winch: "ウインチ",
  pause: "ポーズ",
  keyboard: "キーボード",
  clickToRebind: "クリックで変更",
  pressKey: "キーを押してください...",
  pressGamepadButton: "ボタンを押してください...",
  noGamepad: "ゲームパッド未接続",
  gamepadButtons: "ゲームパッド",
  saved: "保存しました！",
  resetControls: "リセット",
  controlsReset: "操作をリセットしました！",
  movementSensitivity: "感度",
  keyboardLayout: "レイアウト",
  customBindings: "カスタム",
  // UNUSED gamepadSupported: "ゲームパッド OK",
  touch: "タッチ",
  // UNUSED touchSupported: "タッチ OK",
  noGamepadConnected: "ゲームパッド未接続",
  gamepadDiagnostic: "コントローラーテスト",
  connectGamepadDiag: "コントローラーを接続してテスト",
  gamepadDiagButtons: "ボタン",
  gamepadDiagSticks: "スティック",
  gamepadDiagTriggers: "トリガー",

  // Audio
  audio: "オーディオ",
  masterVolume: "マスター音量",
  musicVolume: "音楽",
  sfxVolume: "効果音",
  engineVolume: "エンジン",
  voiceVolume: "ボイス",
  ambienceVolume: "環境音",
  mute: "ミュート",

  backgroundAudio: "バックグラウンドオーディオ",
  // Gameplay
  bonus: "ボーナス",
  skiMode: "滑走モード",
  ski: "スキー",
  snowboard: "スノーボード",
  random: "ランダム",
  skiIt: "滑ろう！",
  rideIt: "ライド！",
  skiAgain: "もう一度！",
  rideAgain: "もう一度！",
  skiRunSpeed: "スピード",
  skiRunTime: "タイム",
  skiRunGates: "ゲート",

  // How to Play hints
  howToPlayMove: "{keys}または矢印キーで移動",
  howToPlayMoveTouch: "仮想Dパッドで移動",
  howToPlayMoveGamepad: "左スティックまたはDパッドで移動",
  howToPlayMoveHybrid: "{keys}/矢印キーまたはタッチDパッド",
  howToPlayGroom: "{groomKey}で圧雪",
  howToPlayGroomTouch: "圧雪ボタンを長押し",
  howToPlayGroomGamepad: "で圧雪",
  howToPlayGroomHybrid: "{groomKey}または圧雪ボタンを長押し",
  howToPlayFuel: "燃料とスタミナに注意！",
  howToPlayWinch: "アンカー付近で{winchKey}でウインチ接続",
  howToPlayWinchTouch: "アンカー付近でウインチボタンを長押し",
  howToPlayWinchGamepad: "アンカー付近でウインチ接続",
  howToPlayWinchHybrid: "{winchKey}またはアンカー付近でウインチボタンを長押し",

  // Winch
  winchSnapped: "💥 ケーブル切断！",
  winchAttached: "🔗 ウインチ接続！{winchKey}長押しで補助。",
  winchActive: "ウインチ",
  // UNUSED winchHint: "番号付きアンカーポストの近くで{winchKey}を押してウインチを使用",
  // UNUSED winchHintTouch: "🔗を長押しでウインチ",
  // UNUSED accessPath: "作業道",
  // UNUSED toPiste: "ゲレンデへ",

  // Taunts - Cliff falls
  tauntCliff1: "9トンが谷底へ。保険会社は大喜びだろう。",
  tauntCliff2: "ジャン=ピエールが「崖に近づくな！」と言ったの覚えてる？",
  tauntCliff3: "パトロール隊がまたロープを持って降りてくる。",
  tauntCliff4: "マリーが今夜のラクレット予約をキャンセルした。",
  tauntCliff5: "ティエリはもう修理費を計算している...",

  // Taunts - Fuel empty
  tauntFuel1: "10分前から燃料警告灯が点いていた。何を見ていた？",
  tauntFuel2: "エミリーが掲示板に「給油」と大文字で書いていた。",
  tauntFuel3: "軽油にも限界がある。君にもあるらしい。",
  tauntFuel4: "ジャン=ピエールがため息。ティエリに携行缶を持たせた。",
  tauntFuel5: "日が昇った。ゲレンデは未整備。スキーヤーが来る。",

  // Taunts - Time limit
  tauntTime1: "始発リフトまで3...2...1...間に合わなかった。",
  tauntTime2: "スキーヤーがゲレンデを発見。ガタガタ。凍結。見事。",
  tauntTime3: "ジャン=ピエールが時計を見て、君を見て、また時計を見る。",
  tauntTime4: "FISがなぜスラロームコースがスープ状なのか聞いている。",
  tauntTime5: "インストラクターがお客に「自分のせいじゃない」と説明しているのが聞こえる。",

  // UNUSED paused: "一時停止",
  resume: "再開",
  quitToMenu: "メニューに戻る",
  levelComplete: "コースクリア！",
  levelFailed: "コース失敗",
  tryAgain: "もう一度",
  coverage: "整備率",
  time: "時間",
  // UNUSED rating: "評価",
  nextLevel: "次のコース",
  // UNUSED replay: "リプレイ",
  // UNUSED pressContinue: "スペースキーまたはタップで続行",
  pauseTitle: "⏸️ 一時停止",
  restart: "やり直し",
  skipRun: "滑走をスキップ",
  newRun: "新しいコース",
  quit: "終了",
  menu: "メニュー",
  levelSelect: "ゲレンデマップ",
  locked: "閉鎖中",
   completeToUnlock: "{name}をクリアして解除",
  // UNUSED target: "目標",
  tutorial: "スキースクール",
  timeUsed: "経過時間",
  excellent: "素晴らしい！",
  good: "よくやった！",
  passed: "合格",
  bonusFuel: "燃料消費",
  bonusFlawless: "初回クリア",
  bonusSpeed: "タイム",
  bonusWinch: "ウインチ使用",
  bonusExplore: "道路探索",
  bonusPrecision: "整備品質",
  retry: "リトライ",
  gameComplete: "ゲームクリア！",
  viewCredits: "クレジット",
  creditsTitle: "おめでとう！",
  creditsSubtitle: "Les Aiguilles Blanchesを制覇しました",
  creditsCreatedBy: "制作",
  creditsDevelopedWith: "開発ツール",
  creditsArtDirection: "アートディレクション",
  creditsRetroInspiration: "SkiFreeなどレトロの名作へのオマージュ",
  creditsInspiredBy: "インスピレーション",
  creditsGroomers: "サヴォワの圧雪車オペレーター",
  creditsDedication: "私たちが眠る間にゲレンデを整備する夜勤チームへ",
  creditsThanks: "プレイありがとう！",
  creditsSeeYou: "ゲレンデでまた会おう！",
  creditsLine: "さあ、行くぞ、小僧。日が昇る。山の準備は整った。",
  playAgain: "もう一度プレイ",
  skipCredits: "キーを押してスキップ",

  // Tutorial
  tutorialName: "チュートリアル - はじめの一歩",
  tutorialTask: "圧雪の基本を学ぶ",
  prologueLine: "午前4時。山はお前のもんだ。仕事だ。",
  prologueSkip: "キーを押して続ける",
  tutorialIntro: "Les Aiguilles Blanchesへようこそ！",
  skipTutorial: "⏭️ チュートリアルをスキップ…タップでリプレイ。",
  skipTutorialGamepad: "⏭️ チュートリアルをスキップ…ボタンでリプレイ。",
  tutorialWelcome: "🏔️ ジャン=ピエール、チーフ圧雪担当だ。ゲレンデを走れ — {keys}か↑↓←→を使え。",
  tutorialWelcomeTouch: "🏔️ ジャン=ピエール、チーフ圧雪担当だ。ゲレンデを走れ — 左のDパッドを使え。",
  tutorialWelcomeGamepad: "🏔️ ジャン=ピエール、チーフ圧雪担当だ。ゲレンデを走れ — 左スティックかDパッドを使え。",
  // UNUSED     tutorialControls: "🎮 圧雪車を動かすには{keys}か矢印キー↑↓←→を使え。",
  // UNUSED     tutorialControlsTouch: "🎮 圧雪車を動かすには左のDパッド◀▲▼▶を使え。",
  // UNUSED     tutorialControlsGamepad: "🎮 圧雪車を動かすには左スティックかDパッドを使え。",
  // UNUSED     tutorialMove: "➡️ さあやってみろ！ゲレンデを走れ — 白い雪を全部圧雪するんだ。",
  // UNUSED     tutorialGroomIntro: "✅ いいぞ！次は圧雪を覚えよう。",
  tutorialGroomAction: "❄️ {groomKey}を押しながら走ると雪が整備される。きれいになるぞ。",
  tutorialGroomActionTouch: "❄️ 右の圧雪ボタンを押しながら走ると雪が整備される。",
  tutorialGroomActionGamepad: "❄️ {groomKey}を押しながら走ると雪が整備される。きれいになるぞ。",
  tutorialGroomGoal: "📊 その調子だ！オープンまでに60%以上を整備しろ。スキーヤーが来るぞ！",
  // UNUSED   tutorialCoverage: "📊 ほら、雪がきれいになった！ゲレンデの圧雪を続けろ。",
  // UNUSED   tutorialHUD: "📈 上のダッシュボードを見ろ：赤が燃料、緑がスタミナ、白が整備率。時間も確認しろ！",
  // UNUSED   tutorialGoal: "🎯 オープンまでにゲレンデの60%以上を整備する必要がある。スキーヤーが来るぞ！",
  // UNUSED tutorialFuel: "⛽ 注意 — 走ると燃料を消費する。ミッションでは給油所に寄れ。",
  tutorialComplete: "🏆 よくやった！基礎はマスターした。初めてのミッション、初級コースに挑戦するか？",

  level_marmottesName: "初級コース - Les Marmottes",
  level_marmottesTask: "初心者ゲレンデを整備",
  level_chamoisName: "中級コース - Le Chamois",
  level_chamoisTask: "オープン前に効率よく整備",
  level_airZoneName: "スノーパーク - Air Zone",
  level_airZoneTask: "フリースタイル設備を準備",
  level_aigleName: "上級コース - L'Aigle",
  level_aigleTask: "急斜面を整備、燃料管理",
  level_glacierName: "上級コース - Le Glacier",
  level_glacierTask: "急斜面でウインチの使い方を学ぶ",
  level_tubeName: "ハーフパイプ - Le Tube",
  level_tubeTask: "大会用ハーフパイプを整備",
  level_verticaleName: "エキスパートコース - La Verticale",
  level_verticaleTask: "夜間作業でウインチ使用",
  level_colDangereuxName: "雪崩エリア - Col Dangereux",
  level_colDangereuxTask: "高リスクエリアを準備",
  level_tempeteName: "暴風雪 - 復旧作業",
  level_tempeteTask: "暴風雪後のゲレンデ復旧",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - FIS決勝",
  level_coupeDesAiguillesTask: "大会に向けて全コースを整備",

  // Hazards
  cliffFall: "⚠️ 警告！崖から落ちた！ミッション失敗。",
  fuelEmpty: "⛽ 燃料切れ！軽油が一滴も残っていない...",
  // UNUSED avalancheZone: "雪崩エリア",
  riskLevelHigh: "高",
  avalancheWarning: "⚠️ 危険！積雪が不安定！エリアから退避せよ！",
  avalancheTrigger: "🏔️💨 雪崩発生！逃げ場なし！",
  steepWarning: "⚠️ 急斜面！ウインチ（{winchKey}）を使え、滑るぞ！",
  steepWarningNoWinch: "⚠️ 急斜面！減速して作業道で迂回しろ！",
  tumble: "🔄 転倒！圧雪車が斜面で転がった！",

  // Taunts - Tumble
  tauntTumble1: "ウインチは飾りじゃない。こういう斜面のためにある。",
  tauntTumble2: "ティエリが損傷を見つめる。何も言わない。それが最悪だ。",
  tauntTumble3: "ジャン=ピエールがアンカーの使い方を見せた。寝てたのか？",
  tauntTumble4: "PistenBullyは6000万円する。いや、したんだがな。",
  tauntTumble5: "この斜面は楽勝に見えた？圧雪車はそう思わなかった。",
  featureDestroyedKicker: 'パークのモジュールに乗り上げた！キッカーが壊れてしまった。',
  featureDestroyedRail: 'パークのモジュールに乗り上げた！レールが壊れてしまった。',
  tauntFeature1: 'あのモジュール、3時間かけて作ったのに。3秒で潰したね。',
  tauntFeature2: 'エミリーがあのパークモジュールについて一言あるそうだ。',
  tauntFeature3: 'パーククルーが傑作を壊されるのを見ていたよ。',
  tauntFeature4: 'モジュールはスキーヤー用。圧雪車は避けて通ろう！',
  tauntFeature5: '明日の大会用のモジュールが一つ減った。',
  bonusPipeMastery: 'ハーフパイプの達人',

  // Taunts - Avalanche
  tauntAvalanche1: "山はめったに許さない。今回も許さなかった。",
  tauntAvalanche2: "Météo Franceが危険度4と言っていた。読んだか？",
  tauntAvalanche3: "春になれば圧雪車が見つかるだろう。たぶん。",
  tauntAvalanche4: "マリーが無線警報を聞いた。もう犯人が分かっている。",
  tauntAvalanche5: "パトロール隊があのエリアを安全にした。君が台無しにした。",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "豪快な転倒。装備はあちこち、プライドはどこにもなし。",
  tauntSkiWipeout2: "崖はお前のスキー技術に興味がなかった。",
  tauntSkiWipeout3: "パトロール隊はもう笑っている。全部見ていた。",
  tauntSkiWipeout4: "自分で整備したゲレンデで転ぶとは。",
  tauntSkiWipeout5: "アイベックスでさえ、あの着地には顔をしかめた。",

  jeanPierreIntro: "チュートリアルはよくやった。ここからが本番だ — 初級コース、タイマーと燃料管理ありだ。",
  level_marmottesMid: "山頂のあの光が見えるか？夜明けだ。この仕事で一番いい瞬間 — お前と、マシンと、目覚める山だけだ。",
  level_chamoisIntro: "やあ、エミリーよ — ジャン=ピエールが中級コースに行かせるって。初級だけじゃないところを見せて。",
  level_airZoneIntro: "スノーパークは私の領域よ — とんでもないコースを作るわ！モジュールは全部完璧に、ライダーが期待してるんだから。",
  level_aigleIntro: "L'Aigleは本格的だ。燃料に注意。作業道で登り返せる — 黄色と黒のポールを探せ。",
  level_glacierIntro: "やあ、ティエリだ — 安全管理責任者。Le Glacierは急斜面だ。アンカーは全部確認済み。ポストの近くで{winchKey}を押してウインチを接続 — 頼むから、離すなよ。",
  level_glacierIntroTouch: "やあ、ティエリだ — 安全管理責任者。Le Glacierは急斜面だ。アンカーは全部確認済み。ポストの近くでウインチボタンをタップ — 頼むから、離すなよ。",
  level_tubeIntro: "明日はTubeでコンテストだ！壁はきれいに、リップはシャープに、凸凹ゼロで頼む。",
  level_verticaleIntro: "La Verticaleで夜間作業：急斜面、危険な縁。ウインチ必須 — 3つのアンカーを使い、軸からずれるな。",
  level_colDangereuxIntro: "Colの雪崩リスクが高い — 雪崩安全プロトコル発動中。荷重エリアに入るな、境界を守れ。",
  level_tempeteIntro: "暴風雪が去った。ホットワインを飲んで — 時間がかかるぞ！",
  level_coupeDesAiguillesIntro: "今夜が勝負だ。明日FISの検査がある。全コース完璧にしろ — 学んだことを見せてくれ。",
  marieWelcome: "マリーの店で温まっていきなさい。美味しいタルティフレットがあるわよ！",
  marieIntro: "こんにちは！マリーよ、ゲレンデ上のレストランをやってるの。いつでも寄ってね — 温かい食事は最高の充電よ！",

  // Changelog
  changelog_20260219_date: "2026年2月19日",
  changelog_20260219: "🎬 新規プレイヤー向けプロローグ\n📖 チュートリアル簡略化\n🌦️ メニューのランダム天候\n🔗 デイリーラン共有\n🎥 シネマティックエンドロール",
  changelog_20260222_date: "2026年2月22日",
  changelog_20260222: "🚩 スラロームゲートの調整\n💬 フィードバックボタン",
  changelog_20260223_date: "2026年2月23日",
  changelog_20260223: "📲 端末にインストールしてオフラインでプレイ",
  changelog_20260220_date: "2026年2月20日",
  changelog_20260220: "🗺️ ゲレンデマップ\n🎿 スキー場用語",
  changelog_20260217_date: "2026年2月17日",
  changelog_20260217: "🏔️ 7種のコース形状\n🎯 コース生成の多様性\n⚡ スキー滑走改善",
  changelog_20260216_date: "2026年2月16日",
  changelog_20260216: "🎲 今日のゲレンデ",
  changelog_20260215_date: "2026年2月15日",
  changelog_20260215: "⚡ 夜間レンダリング刷新\n📱 スキーモードタッチボタン\n⌨️ キーボード配列検出",
  changelog_20260214_date: "2026年2月14日",
  changelog_20260214: "🎪 トリックスコア＆コンボ\n🏂 タック＆ハーフパイプ物理\n👁️ ゲレンデのコントラスト改善\n📱 ウインチ時の自動整地（タッチ）\n♿ ハイコントラストモード",
  changelog_20260213_date: "2026年2月13日",
  changelog_20260213: "🚩 スラロームゲート\n🏔️ スキージャンプ\n⚡ パフォーマンス改善\n🎹 ノクターンピアノ音楽\n🔊 エンジン音量調整",
  changelog_20260212_date: "2026年2月12日",
  changelog_20260212: "📋 ゲレンデマップ\n🔗 切断可能ウインチケーブル\n🕹️ コントローラー診断\n🍽️ マリーの料理\n❄️ 凍結効果",
  changelog_20260211_date: "2026年2月11日",
changelog_20260211: "⛷️ 整備後のスキー滑走\n🎯 整備品質\n🏔️ 急斜面の色分け表示\n🏗️ パークとトリック",
  changelog_20260210_date: "2026年2月10日",
  changelog_20260210: "🎵 音楽と効果音\n🔈 音量設定\n⏱️ 自動調整コースタイム\n⏭️ チュートリアルスキップ\n🏔️ 雪崩エリア再設計",
  changelog_20260209_date: "2026年2月9日",
  changelog_20260209: "🏔️ アルプス風クリア/失敗画面\n❄️ 暴風雪の積雪\n🏆 ノーミスボーナス\n🔊 天候と野生動物の環境音",
  changelog_20260208_date: "2026年2月8日",
  changelog_20260208: "📊 ダッシュボード刷新\n🏔️ Le GlacierとCoupe des Aiguilles\n🦅 高山の野生動物\n🎨 キャラクターポートレート\n🎮 キーボード/ゲームパッド操作",
  changelog_20260207_date: "2026年2月7日",
  changelog_20260207: "🎨 レトロUI\n🎯 ボーナス目標\n🕹️ ゲームパッドボタン変更\n🎮 ゲームパッドメニュー操作",
  changelog_20260206_date: "2026年2月6日",
  changelog_20260206: "🛤️ 走行可能な作業道\n🕹️ 仮想ジョイスティック\n🌍 5言語対応",
  changelog_20260205_date: "2026年2月5日",
  changelog_20260205: "🏔️ 岩崖\n🌙 夜間ヘッドライト\n🔗 ウインチ機構\n⌨️ キーボード操作",
  changelog_20260204_date: "2026年2月4日",
  changelog_20260204: "🎮 ゲームパッド対応\n📱 タッチ操作\n💪 スタミナ\n💾 セーブ機能\n♿ アクセシビリティ",
  changelog_20260203_date: "2026年2月3日",
  changelog_20260203: "🚜 リリース：9コース、スキースクール\n❄️ 圧雪、燃料、雪崩\n🏆 クレジットと進行",
  // Key names
  key_space: "スペース",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "DEL",
  dailyRuns: "今日のゲレンデ",
  dailyRuns_dailyShift: "日勤",
  dailyRuns_randomRun: "ランダムラン",
  dailyRuns_rank: "ランク",
  dailyRuns_seed: "シード",
  // UNUSED   dailyRuns_start: "契約を開始",
  dailyRuns_locked: "全コースをクリアして解放",
  dailyRuns_lockedShared: "全コースをクリアしてデイリーランを解放し、この共有コースをプレイしよう",
  // UNUSED   dailyRun_levelName: "契約",
  dailyRun_levelTask: "目標カバー率までゲレンデを整備せよ",
  dailyRuns_briefing: "概要",
  dailyRuns_target: "目標",
  dailyRuns_timeLimit: "制限時間",
  dailyRuns_weather_clear: "快晴",
  dailyRuns_weather_light_snow: "小雪",
  dailyRuns_weather_storm: "吹雪",
  dailyRuns_night: "夜勤",
  dailyRuns_day: "日勤",
  rank_green: "グリーン",
  rank_blue: "ブルー",
  rank_red: "レッド",
  rank_black: "ブラック",
  rank_park: "パーク",
  share: "共有",
  copied: "リンクをコピーしました！",
  playSharedSeed: "共有ラン",
  dailyRunBriefingJP: "リフトが動く前にゲレンデを仕上げろ。さっさとやれ。",
  dailyRunBriefingThierry: "気をつけろよ——急斜面に不安定な雪だ。油断するな。",
  dailyRunBriefingMarie: "今夜は冷え込むわよ。体が冷えたらレストランに寄ってね。",
  dailyRunBriefingEmilie: "また一本ゲレンデね。私のタイムに勝てるかな？"
};

export default ja;
